__turbopack_context__.v({
  "elevenTop": "Waves-module-scss-module__wLN-ta__elevenTop",
  "fiveBottom": "Waves-module-scss-module__wLN-ta__fiveBottom",
  "fiveTop": "Waves-module-scss-module__wLN-ta__fiveTop",
  "heroBottomWave": "Waves-module-scss-module__wLN-ta__heroBottomWave",
  "heroBottomWavePatient": "Waves-module-scss-module__wLN-ta__heroBottomWavePatient",
  "nineBottom": "Waves-module-scss-module__wLN-ta__nineBottom",
  "oneTop": "Waves-module-scss-module__wLN-ta__oneTop",
  "oneTopWhiteSpace": "Waves-module-scss-module__wLN-ta__oneTopWhiteSpace",
  "sevenBottom": "Waves-module-scss-module__wLN-ta__sevenBottom",
  "sevenTop": "Waves-module-scss-module__wLN-ta__sevenTop",
  "shapeFill": "Waves-module-scss-module__wLN-ta__shapeFill",
  "topNine": "Waves-module-scss-module__wLN-ta__topNine",
  "twelveBottom": "Waves-module-scss-module__wLN-ta__twelveBottom",
  "twelveTop": "Waves-module-scss-module__wLN-ta__twelveTop",
  "twoBottom": "Waves-module-scss-module__wLN-ta__twoBottom",
  "twoTop": "Waves-module-scss-module__wLN-ta__twoTop",
});
